module.exports = __webpack_public_path__ + "media/assets/icons/ic-credit-card-0b431a1ef55faea39ca763c1989270c4.svg";